import React, { useEffect, useState } from "react";
import Spinner from "../../components/_common/Spinner";
import OneBarChart from  '../../components/_common/BarChart/OneBarChart'
const chart_data = [
  {
    name: "نصب شده کل",
    buy: 16,
    color:'#12db98'
  },
  {
    name: "فعال امروز",
    buy: 3,
    color: '#12c4db',
  },
  {
    name: "غیرمجاز امروز",
    buy: 2,
    color: '#dba212',
    
  },
  
];
export interface InputProps {
  data: any,
  isloading: Boolean; 
}

const Material = ({  data, isloading}: InputProps) => {

  let chartData:any[]=[];
  let flag = false;

  useEffect(() => {
    
    
  }, [])
 
  const getChartData =()=>{
    data.map((item:any)=>{
      chartData.push({name:"نصب شده کل", count:item.AllSensorCount,color:'#12db98'});
      chartData.push( {name:"فعال امروز", count:item.ActiveSensorCount,color:'#12c4db'});
      chartData.push({name:"غیرمجاز امروز", count:item.CrashSensorCount,color:'#dba212'});
    })

    chartData.map((item:any)=>{
      if(item.count !==0 ) {
        flag = true;
        return;
      }
    })
  }
 
  return (
    <>
    {isloading === false && (
        getChartData(),
        <>
        { 
        flag &&(
        <OneBarChart data={chartData} label="سنسور دماسنج" dataKey="count"/>
        )
      } 
      {
       flag === false &&
       (<p className="empty-data">داده ای برای نمایش موجود نیست.</p>)
      }
      </>
     )
     
 }

    {isloading === true && (
        <Spinner />
    )}

    </>
  )
}
export default Material;